export default "__VITE_ASSET__3030d329__"